import create from 'zustand'
import { IolLibrary } from '../../types/graphql'
import { ProcedureItem } from '../Config/Procedures/types'
import { Patient } from '../Pacients/PacientCard'

type BudgetFormValues = {
  patient?: Patient
  items: ProcedureItem[]
  discount: number
  observation?: string
  iols: Array<IolLibrary & { side: 'left' | 'right' }>
  id?: string
  numberOs?: string
}

type BudgetFormActions = {
  setPatient: (patient: Patient) => void
  appendOrderItem: (orderItem: ProcedureItem) => void
  removeOrderItem: (index: number) => void
  reset: () => void
  setDiscount: (discount: number) => void
  setObservation: (observation: string) => void
  setId: (id?: string) => void
  set: (values: BudgetFormValues) => void
  addIol: (iol: IolLibrary & { side: 'left' | 'right' }) => void
  removeIol: (index: number) => void
  updateIolSide: (index: number, newSide: 'left' | 'right') => void
}

export type BudgetFormState = BudgetFormValues & BudgetFormActions

const initialState: BudgetFormValues = {
  items: [],
  discount: 0,
  iols: [],
  patient: undefined,
  observation: '',
  id: undefined
}

export const useBudgetForm = create<BudgetFormState>((set, get) => ({
  ...initialState,
  setPatient: patient => set(state => ({ ...state, patient })),
  appendOrderItem: orderItem =>
    set(state => ({ ...state, items: [...state.items, orderItem] })),
  removeOrderItem: index =>
    set(state => ({
      ...state,
      items: state.items.filter((_, i) => i !== index)
    })),
  reset: () => {
    set(() => initialState)
  },
  setDiscount: discount => set(state => ({ ...state, discount })),
  setObservation: observation => set(state => ({ ...state, observation })),
  setId: id => set(state => ({ ...state, id })),
  set: values => set(state => ({ ...state, ...values })),
  addIol: iol => set(state => ({ ...state, iols: [...state.iols, iol] })),
  removeIol: index =>
    set(state => ({
      ...state,
      iols: state.iols.filter((_, i) => i !== index)
    })),
  updateIolSide: (index, newSide) => {
    const newIols = [...get().iols]
    newIols[index].side = newSide
    set({ iols: newIols })
  }
}))
